import { CommonModule } from "@angular/common";
import { Component, computed, input, ViewEncapsulation } from "@angular/core";
import { CalendarData } from "../../modules/home/calendar/CalendarData";
import { S25ItemBean } from "../../modules/s25-item/s25.item.component";
import { S25ItemModule } from "../../modules/s25-item/s25.item.module";
import { Item } from "../../pojo/Item";
import { Task } from "../../pojo/Task";
import { S25Util } from "../../util/s25-util";

@Component({
    selector: "s25-ng-calendar-subject",
    standalone: true,
    imports: [CommonModule, S25ItemModule],
    template: `
        @if (subject().is_hidden) {
            <div class="ngHiddenSubject">{{ subject().itemName }}</div>
        } @else if (+subject().itemTypeId === Item.Ids.Task) {
            <s25-item
                class="item s25-object ngSubjectItem"
                [modelBean]="taskBean()"
                [includeTypeIcon]="true"
                [blockContextMenu]="true"
            ></s25-item>
        } @else {
            <s25-item-generic
                class="item ngSubjectItem"
                [itemId]="+subject().itemId"
                [itemTypeId]="+subject().itemTypeId"
                [itemName]="subject().itemName"
                [contextMenuOnBody]="true"
                [includeTypeIcon]="true"
            />
        }
        @if (subject().has_more && isLast()) {
            <div class="ngInlineBlock ngWidth100 ngMultLocMsg {{ Reservation.classes(reservation()) }}">
                <i class="ngMultipleSubject">(more {{ PluralName[itemTypeId()] }})</i>
            </div>
        }
        @if (subject().comment) {
            <div class="ngComment">{{ subject()?.comment }}</div>
        }
    `,
    encapsulation: ViewEncapsulation.Emulated,
    styles: `
        .item ::ng-deep .s25-item-holder {
            display: inline-flex;
            align-items: center;
            padding: 3px 1px;
        }
    `,
})
export class CalendarSubject {
    readonly subject = input.required<CalendarData.Subject>();
    readonly reservation = input.required<CalendarData.Reservation>();
    readonly isLast = input<boolean>(false);

    readonly itemTypeId = computed<Item.Id>(() => S25Util.parseInt(this.subject().itemTypeId));
    readonly taskBean = computed<S25ItemBean>(() => ({
        ...this.subject(),
        itemId: this.subject().taskId ?? this.subject().itemId,
        itemTypeId: this.itemTypeId(),
        typeIcon: {
            styleClass: Task.State.iconClass(this.subject().itemStateId),
            isActive: true,
        },
    }));

    protected readonly Item = Item;
    protected readonly Reservation = CalendarData.Reservation;
    protected readonly PluralName: { [typeId in Item.Id]?: string } = {
        [Item.Ids.Organization]: "organizations",
        [Item.Ids.Location]: "locations",
        [Item.Ids.Resource]: "resources",
        [Item.Ids.Task]: "tasks",
    };
}
